import React, { useState } from 'react';

import { ValidateConfig, createValidator } from '../../../utils/validationFrom';

interface Props<Fields extends {}> extends Omit<React.AllHTMLAttributes<HTMLFormElement>, 'children' | 'onSubmit'> {
  initialState?: Fields;
  children: (params: {
    fields: Fields;
    errors: Record<keyof Fields, boolean | string>;
    handleChange: React.FormEventHandler;
    setError: (key, value) => void;
  }) => JSX.Element;
  validateConfig: ValidateConfig<Fields>;
  onSubmit: (fields: Fields) => void;
}

export function Form<Fields extends {}>({
  initialState = {} as Fields,
  children,
  validateConfig,
  onSubmit,
  ...props
}: Props<Fields>) {
  const [fields, setFields] = useState<Fields>(initialState);
  const [errors, setErrors] = useState<Record<keyof Fields, boolean | string>>(
    {} as Record<keyof Fields, boolean | string>,
  );

  const resetError = (name: string) => {
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleChange: React.FocusEventHandler = (e) => {
    //@ts-ignore
    const value = e.target.value;
    //@ts-ignore
    const name = e.target.name;
    resetError(name);
    setFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validator = createValidator(validateConfig);
    const [validationResult, isNotValid] = validator(fields);

    if (isNotValid) {
      setErrors(validationResult);
    } else {
      onSubmit?.(fields);
    }
  };

  const setError = (key: keyof Fields, value: string | boolean) => {
    setErrors((prev) => ({ ...prev, [key]: value }));
  };
  return (
    <form {...props} onSubmit={handleSubmit}>
      {children({ fields, errors, handleChange, setError })}
    </form>
  );
}
